// Those objects class are used as responsed from the BIMSearch engine

export class QuickDataField {
    constructor(name, value = 0, unit = null) {
        this.name = name;
        this.value = value;
        this.unit = unit;
    }
}

export class TestResult {
    constructor() {
        this.discipline = "";
        this.stage = "";
        this.score = 0;
        this.tables = []; // [] of TestTable
    }
}

export class TestTable {
    constructor() {
        this.title = "";
        this.header = []; // size n [] of strings
        this.lines = []; // size m [] of size n [] of values (string or numbers)
        this.totals = []; // size n [] of values (string or numbers)
        this.lineElements = []; // size m [] of [] of ids
        this.missingProperties= []; // size m[] of size n[] of [] of elements ids
    }
}


export const Stages = {"אחזקה" : 5, "מידע לביצוע" : 4, "תכנון מפורט": 3, "תכנון סופי": 2, "תכנון ראשוני" : 1};
